import { DataTable, Timeline } from "@/components";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui";
import { historyTabs, TIMELINE } from "../consts";
import useOwnershipHistory from "./useOwnershipHistory";

const OwnershipHistory = () => {
  const {updatedTimeline, onTabChange, activeTab, columns} = useOwnershipHistory();

  return (
    <div>
      <div className="flex flex-row items-center justify-between w-full">
        <div className="mb-3">{updatedTimeline?.length} Ownership Records</div>
        <div>
          <Tabs defaultValue="timeline" className="my-4 bg-gray-100 rounded-sm">
            <TabsList className="gap-x-4">
              {historyTabs?.map((data: any) => (
                <TabsTrigger
                  key={data?.value}
                  value={data?.value}
                  className="shadow-none hover:cursor-pointer data-[state=active]:rounded-sm data-[state=active]:bg-white data-[state=active]:text-primary"
                  onClick={() => onTabChange(data.value)}
                >
                  {data?.title}
                </TabsTrigger>
              ))}
            </TabsList>
          </Tabs>
        </div>
      </div>
      {activeTab == TIMELINE ? 
          <Timeline items={updatedTimeline} /> :
          <DataTable 
            data={updatedTimeline}
            columns={columns} 
            className="shadow-none"
            hideFooter
          />
        }
    </div>
  )
}

export default OwnershipHistory;